import React from 'react';
import { Radio } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as layoutActions from '_legacy/actions/layoutActions';
import {
    LONG_HAND_RATE_FORMAT,
    SHORT_HAND_RATE_FORMAT,
} from '_legacy/modules/columns/rate/services/RateFormatServiceFactory';

const panelContainerStyle = () => {
    return {
        textAlign: 'left',
        display: 'inline-grid',
        lineHeight: '1.5',
        marginTop: '5px',
        marginLeft: '50px',
    };
};

const labels = {
    LONG_HAND_RATE_FORMAT: 'Long Hand',
    SHORT_HAND_RATE_FORMAT: 'Short Hand',
};

const RateFormatItems = (props) => {
    const handleOnChangeRateFormat = (rateFormat) => {
        updateLayout(rateFormat);
        props.api.refreshClientSideRowModel();
    };

    const isChecked = (value) => {
        return value === props.currentRateFormat;
    };

    const updateLayout = (rateFormat) => {
        props.actions.onRateFormatChanged(rateFormat);
    };

    return (
        <div style={panelContainerStyle()}>
            <Radio
                checked={isChecked(LONG_HAND_RATE_FORMAT)}
                onChange={() => handleOnChangeRateFormat(LONG_HAND_RATE_FORMAT)}
                label={labels.LONG_HAND_RATE_FORMAT}
            />
            <Radio
                checked={isChecked(SHORT_HAND_RATE_FORMAT)}
                onChange={() =>
                    handleOnChangeRateFormat(SHORT_HAND_RATE_FORMAT)
                }
                label={labels.SHORT_HAND_RATE_FORMAT}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        currentRateFormat:
            state.layouts.selectedLayout.commonSettings.rateFormat.currentState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...layoutActions }, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RateFormatItems);
